import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useState } from "react";
import { useRegisterCallbacks } from "./ConversationContext.js";
const ConversationModeContext = createContext(null);
/**
 * Reads from `ConversationContext` and registers an `onModeChange` callback.
 * Manages its own `mode` state and provides it through
 * `ConversationModeContext`. Must be rendered inside a `ConversationProvider`.
 */
export function ConversationModeProvider({ children, }) {
    const [mode, setMode] = useState("listening");
    useRegisterCallbacks({
        onModeChange({ mode: newMode }) {
            setMode(newMode);
        },
        onDisconnect() {
            setMode("listening");
        },
    });
    const value = useMemo(() => ({
        mode,
        isSpeaking: mode === "speaking",
        isListening: mode === "listening",
    }), [mode]);
    return (_jsx(ConversationModeContext.Provider, { value: value, children: children }));
}
/**
 * Returns the current conversation mode (speaking/listening) and
 * convenience booleans. Re-renders only when the mode changes.
 *
 * Must be used within a `ConversationProvider`.
 */
export function useConversationMode() {
    const ctx = useContext(ConversationModeContext);
    if (!ctx) {
        throw new Error("useConversationMode must be used within a ConversationProvider");
    }
    return ctx;
}
//# sourceMappingURL=ConversationMode.js.map